"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var react_effect_1 = require("@shopify/react-effect");

var assets_1 = require("./context/assets");

function useAsyncAsset(id) {
  var assets = react_1.useContext(assets_1.AsyncAssetContext);
  react_effect_1.useServerEffect(function () {
    if (assets && id) {
      assets.markAsUsed(id);
    }
  });
}

exports.useAsyncAsset = useAsyncAsset;